import { Row } from "antd";
import { useMemo } from "react";
import { useFormatMsgTime } from "../hooks/useFormatMsgTime";
import { IMessage } from "../../../types/Message";
import { AttachmentList } from "./AttachmentList";

type MessageProps = {
  conversationId: string;
  item: IMessage;
};

export const Message = ({ conversationId, item }: MessageProps) => {
  const containerClass: string = useMemo(
    () => `${item.isMine ? "justify-end" : ""}`,
    [item],
  );

  const hasFiles: boolean = useMemo(
    () => !!(item.attachments && item.attachments.length > 0),
    [item],
  );

  const msgClass: string = useMemo(
    () =>
      `d-block message-body px-6 py-4 ${item.isMine ? "self" : ""} ${
        hasFiles ? "has-files" : ""
      }`,
    [item, hasFiles],
  );

  const { format } = useFormatMsgTime();

  return (
    <Row className="message d-block mb-4">
      <Row className={`${containerClass} align-center px-6`}>
        {!item.isMine && (
          <>
            <span className="text-sm title user-name elipsis">
              {item.senderName}
            </span>
            <div className="elipse mx-1" />
          </>
        )}
        <span className="text-sm title">{format(item.sentAt)}</span>
      </Row>
      <Row className={containerClass}>
        <Row className={msgClass}>
          <p className="my-0 text">{item.text}</p>
          {hasFiles && (
            <AttachmentList
              conversationId={conversationId}
              items={item.attachments}
            />
          )}
        </Row>
      </Row>
    </Row>
  );
};
